function Art() {
  return(
    <div id="art" className="component">
      <h1>works</h1>
      <h2>selected pieces from interdisciplinary practice</h2>
      
      <div>
        <img src="saxophone-study-13.jpg" alt="Saxophone Study #13"/><br/>
        <h3>Saxophone Study #13</h3>
        <h4><i>2024</i>, pencil on paper and ink on tracing in glass frame<br/>
        20 x 12 in.</h4>

        <img src="DSC08496.JPG" alt="Microphone installation"/><br/>
        <h3>Untitled</h3>
        <h4><i>2024</i>, seven microphone stands and microphones<br/>
        Installation</h4>

        <img src="saxophone-study-12.jpeg" alt="Saxophone Study #12"/><br/>
        <h3>Saxophone Study #12</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="saxophone-study-11.jpeg" alt="Saxophone Study #11"/><br/>
        <h3>Saxophone Study #11</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="saxophone-study-10.jpeg" alt="Saxophone Study #10"/><br/>
        <h3>Saxophone Study #10</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>
        
        <img src="saxophone-study-9.jpeg" alt="Saxophone Study #9"/><br/>
        <h3>Saxophone Study #9</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="saxophone-study-8.jpeg" alt="Saxophone Study #8"/><br/>
        <h3>Saxophone Study #8</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="saxophone-study-7.jpeg" alt="Saxophone Study #7"/><br/>
        <h3>Saxophone Study #7</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="saxophone-study-6.jpeg" alt="Saxophone Study #6"/><br/>
        <h3>Saxophone Study #6</h3>
        <h4><i>2024</i>, photo<br/>
        12 x 12 in.</h4>

        <img src="DSC08454.jpeg" alt="Saxophone Study #5"/><br/>
        <h3>Saxophone Study #5</h3>
        <h4><i>2024</i>, air-dry clay<br/>
        4 x 1½ x 1 in.</h4>

        <img src="DSC08480.jpeg" alt="Saxophone Study #4"/><br/>
        <h3>Saxophone Study #4</h3>
        <h4><i>2024</i>, acrylic on canvas; sound<br/>
        36 x 36 in.; 7 minutes</h4>

        <img src="DSC08476.jpeg" alt="Saxophone Study #3"/><br/>
        <h3>Saxophone Study #3</h3>
        <h4><i>2024</i>, acrylic on canvas; sound<br/>
        36 x 36 in.; 7 minutes</h4>

        <img src="DSC08462.jpeg" alt="Saxophone Study #2"/><br/>
        <h3>Saxophone Study #2</h3>
        <h4><i>2024</i>, acrylic on canvas; sound<br/>
        24 x 24 in.; 7 minutes</h4>

        <img src="DSC08446.jpeg" alt="Saxophone Study #1"/><br/>
        <h3>Saxophone Study #1</h3>
        <h4><i>2024</i>, gesso, ink, pencil on paper; sound<br/>
        24 x 24 in.; 7 minutes</h4>

        <img src="HEI_230728_07.jpg" alt="Songbook for Black Constellations, for Trio" /><br/>
        <img src="HEI_230728_20.jpg" alt="Songbook for Black Constellations, for Trio alt" /><br/>
        <img src="HEI_230728_16.jpg" alt="Songbook for Black Constellations, for Trio second alt 2" /><br/>
        <h3>Songbook for Black Constellations, for Trio</h3>
        <h4><i>2023</i>, acrylic, chalk, house paint, pencil on wood panel; sound<br/>
        (left to right) 72 x 48 in., 72 x 48 in., 72 x 72 in., 72 x 48 in., 72 x 48 in.</h4>

        <img src="030-AR5_7563.jpg" alt="Heirloom I, for Jazz" />
        <h3>Heirloom I, for Jazz</h3>
        <h4><i>2023</i>, cassette; sound</h4>

        <img src="015-5DSR0426.jpg" alt="7 Trains to Mecca" />
        <h3>7 Trains to Mecca</h3>
        <h4><i>2023</i>, acrylic on wood panel, tuning pegs, and piano string*</h4>

        <img src="Corey_Sherrard_7.jpg" alt="Constellation for Black Masses in Amerikkka" />
        <h3>Constellation for Black Masses in Amerikkka</h3>
        <h4><i>2022</i>, acrylic, ink, pencil on wood panel; sound*<br/>
        36 x 24 in.; <a href="https://beauyeroc.bandcamp.com/track/constellation-for-black-masses-in-amerikkka" target="_blank" rel="noreferrer">1 minute, 30 seconds</a></h4>

        <img src="constellation for black meccas in amerikkka [2022] [cropped].jpg" alt="Constellation for Black Meccas in Amerikkka[?]" />
        <h3>Constellation for Black Meccas in Amerikkka[?]</h3>
        <h4><i>2022</i>, acrylic, ink, pencil on wood panel; sound*<br/>
        36 x 24 in.; <a href="https://beauyeroc.bandcamp.com/track/constellation-for-black-meccas-in-amerikkka" target="_blank" rel="noreferrer">2 minutes</a></h4>

        <img src="theme i, for negro league baseball [2022] [cropped].jpg" alt="Theme I, for Negro League Baseball" />
        <h3>Theme I, for Negro League Baseball</h3>
        <h4><i>2022</i>, acrylic, ink, pencil on wood panel; sound*<br/>
        36 x 36 in.; <a href="https://beauyeroc.bandcamp.com/track/theme-i-for-negro-league-baseball-2" target="_blank" rel="noreferrer">2 minutes</a></h4>

        <img src="010-5DSR0418.jpg" alt="Black Education 42/50, pg. 1 + 2" />
        <h3>Black Education 42/50, pg. 1 + 2</h3>
        <h4><i>2022</i>, acrylic, ink, pencil on wood panel[s]; sound*<br/>
        36 x 24 in., 36 x 24 in.; <a href="https://beauyeroc.bandcamp.com/track/black-education-42-50-pg-1-2" target="_blank" rel="noreferrer">4 minutes</a></h4>

        <img src="Corey_Sherrard_5.jpg" alt="US Primer" />
        <h3>US Primer</h3>
        <h4><i>2022</i>, acrylic, ink, pencil on wood panel; sound*<br/>
        36 x 24 in.; <a href="https://beauyeroc.bandcamp.com/track/us-primer" target="_blank" rel="noreferrer">2 minutes</a></h4>
      </div>
      <h3>credits</h3>
      <p>
        The photos of <i>7 Trains to Meccas</i>, <i>Constellation for Black Masses in Amerikkka</i>, <i>Constellation for Black Meccas in Amerikkka[?]</i>
        , <i>Theme I, for Negro League Baseball</i>, <i>Black Education 42/50, pg. 1 + 2</i>, and <i>US Primer</i> were taken by <a href="https://www.instagram.com/visibleinlight/?hl=en"><b>Alex Barber</b></a>.
        The photos of <i>Songbook for Black Constellations, for Trio</i> were taken by <a href="https://www.lawrenceelizabeth.com/" target="_blank" rel="noreferrer"><b>Lawrence Elizabeth Knox</b></a>.
      </p>
    </div>
  )
}

export default Art;